import styled from 'styled-components'
import MasterCard from "web/assets/images/master-card-icon.png";
import VisaCard from "web/assets/images/visa-card-icon.png";
import AmericanCard from "web/assets/images/american-express-icon.png";
import DiscoverCard from "web/assets/images/discover-card-icon.png";
import ClubCard from "web/assets/images/club-card-icon.png";
import JcbCard from "web/assets/images/jcb-card-icon.png";
import StepperImage from "web/assets/images/stepper-image.png";
// import StepperFirstBlueImage from "web/assets/images/first-step-blue.png";
const RegistrationStepper = styled.div`
  background-image: linear-gradient(to bottom, #fff, #ccc6c6);
  position: fixed;
    width: 100%;
    top: 81px;
    z-index: 1;
  .step-number {
    font-family: "arialbold";
    font-size: 33px;
    margin-right: 4px;
  }

  .MuiStepLabel-iconContainer,
  .MuiStepConnector-root {
    display: none;
  }
  .MuiStepper-horizontal {
    background-image: linear-gradient(to bottom, #fff, #ccc6c6);
    .MuiStepLabel-active{
      color: #fff;
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.16);
      background-color: #0a5587;
      position: relative;
      margin-right: 14px;
      margin-left: 14px;
      padding: 0;
      background-image: none;
      ::after {
        content: "";
        display: inline-flex;
        width: 0;
        height: 0;
        border: 0 solid transparent;
        border-top-width: 24.5px;
        border-bottom-width: 24.5px;
        border-left: 14px solid #0a5587;
        position: absolute;
        right: -14px;
        z-index: 2;
      }
      ::before {
        content: "";
        display: inline-flex;
        width: 0;
        height: 0;
        border: 0 solid #0a5587;
        border-top-width: 24.5px;
        border-bottom-width: 24.5px;
        border-left: 14px solid transparent;
        position: absolute;
        left: -14px;
      }
      @media (max-width: 650px) {
        .MuiStepLabel-active {
          margin-left: 0;
        }
      }
    }
  }
  .MuiStep-horizontal {
    flex: 1;
    text-align: center;
    padding: 0;
  }

  .MuiStepLabel-root {
    height: 49px;
    justify-content: center;
  }
  .MuiStep-completed {
    .MuiStepLabel-label {
      ::after {
        right: -21px;
      }
    }
  }
  .MuiStepLabel-label.MuiStepLabel-completed {
    color: #61ae24;
    padding: 0 16px;
  }
  .MuiStepLabel-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: "latobold" !important;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.16);
    background-image: linear-gradient(to bottom, #fff, #ccc6c6);
    color: #6c6c6c;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
    position: relative;
    ::after {
      content: "";
      background-image: url(${StepperImage});
      display: inline-flex;
      width: 21px;
      height: 100%;
      position: absolute;
      background-repeat: no-repeat;
      right: 0;
      z-index: 1;
    }
    :last-child {
   
    }
  }
  .MuiStepLabel-labelContainer {
    height: 100%;
  }
  .MuiStepper-root {
    padding: 0;
    width: 100%;
    max-width: 1435px;
    margin: 0 auto;
    padding: 0 98px;
    > .MuiStep-horizontal:first-child {
      .MuiStepLabel-active {
        margin-left: 0;
        :before {
          display: none;
        }
      }
    }
  }
  @media (max-width: 1250px) {
    .MuiStepper-root {
      padding: 0;
    }
  }
`;

const FormSection = styled.div`
  width: 100%;
  .label-color {
    color: #191819;
    font-size: 17px;
    font-family: "latoregular";
    p {
      margin-top: 0;
      margin-bottom: 12px;
    }
    .star {
      color: #a30202;
    }
  }
  .submitBtn {
    max-width: 151px;
    width: 100%;
    border-radius: 5px;
  }
  .app-input-text {
    margin-bottom: 15px;
    input {
      border-radius: 5px;
      border: solid 1px #87cdf1;
    }
  }
`;

const ImageSection = styled.div`
  flex: 1;
  padding: 30px 60px;
  display: flex;
  justify-content: center;
  justify-content: center;
  align-items: baseline;
  img {
    position: sticky;

    width: 106%;
    top: 239px;
  }
  @media (max-width: 1250px) {
    img {
      left: -15px;
      width: 100%;
      padding-right: 46px;
    }
  }
  @media (max-width: 965px) {
    display: none;
  }
`;

const StepOneContainer = styled.div`
    display: flex;
    align-items: center;
`
const FormWrapper = styled.div`
  border-radius: 10px;
  background-color: #fff;
  padding: 26px;
  flex: 1;
  .textAreaClass{
    .app-input-text textarea{
      height: 38px;
    }
  }
  .diverse-spend-multiselect-style{
    .select__control{
      border-color: #87cdf1;
    }
  }  
  .select-height {
    min-height: 99px;
  }
  .otp-input-container {
    display: flex;
    justify-content: space-between;
    width: 375px; /* Adjust the width as needed */
    margin: 15px auto 0px auto; /* Center the OTP input field */
    input[type="text"], input[type="number"] {
      box-shadow: 2px 2px 4px 0px #0000001F inset;
      border: none;
      border-radius: 8px;
      width: 40px; /* Adjust the width of each input box */
      height: 40px; /* Adjust the height of each input box */
      text-align: center;
      font-size: 18px; /* Adjust the font size */
      margin: 0 12px; /* Adjust the margin between boxes */
      background: #F6F6F6;
    }

    input[type="text"]:focus, input[type="number"]:focus {
      outline: none; /* Remove the focus outline */
      border-color: #007bff; /* Change border color on focus */
    }
  }
  .optButtonStyle{
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }
  @media (max-width:903px) {
     .otp-input-container {
        width: 310px;

        input[type="text"], input[type="number"] {
          margin: 0 6px;
        }
    }
    .optButtonStyle{
      display: flex;
      justify-content: center;
      margin-top: 40px;
      .submitBtn{
        max-width: 230px;
      }
    }
  }
  @media (max-width: 965px) {
    max-width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  position: absolute;
  bottom: 36px;
  width: calc(100% - 69px);
  .step-2 {
    bottom: 85px;
  }
  .submitBtn {
    margin-right: 15px;
  }
`;
const BackButtonWrapper = styled.div`
    padding-top: 20px;
    display: flex;
    align-items: center;
`
const SubHeading = styled.h3`
  font-size: 21px;
  text-align: left;
  font-family: "latobold";
  margin-bottom: 30px;
  width: 100%;
  position: relative;
  padding-left: 80px;
  .right-arrow {
    position: absolute;
    left: -15px;
    top: -12px;
  }
`;
const PromoCode = styled.h3`
  color: #505050;
  font-size: 22px;
  font-family: "latobold";
  margin-bottom: 30px;
  width: 100%;
`;
const StepTwoContainer = styled.div`
    display: flex;
`
const AccountTypeSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 20px 20px 0 0;
  background-color: #fff;
`;
const CardTypeSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-top: 0;
  background-color: #fff;
  .radioButtonClass{
    span{
      white-space: nowrap;
    }
  }
`;
const CardTypeSectionStripe = styled.div`
  flex: 1;
  border-top: 0;
  background-color: #fff;
  .pf {
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    width: 41px;
    height: 27px;
    :before {
      display: none;
    }
  }
  .pf-mastercard {
    background-image: url(${MasterCard});
  }
  .pf-visa {
    background-image: url(${VisaCard});
  }
  .pf-american-express {
    background-image: url(${AmericanCard});
  }
  .pf-discover {
    background-image: url(${DiscoverCard});
  }
  .pf-diners {
    background-image: url(${ClubCard});
  }
  .pf-jcb {
    background-image: url(${JcbCard});
  }
`;
const StepThreeContainer = styled.div`
  display: flex;
  .text-area-wrapper {
    .app-input-text {
      margin-bottom: 0;
    }
  }
`;

const BusinessInfoSection = styled.div`
  flex: 1;
  padding: 0px 15px;
  border-radius: 0;
  border-top: 0;
  background-color: #fff;
`;
const StepFourContainer = styled.div`
    display: flex;
    .account-edit-icon{
      cursor:pointer;
    }
    .freezeDiv{
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 99;
    }
    .freezeDivCredit{
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 99;
    }
    .date-of-birth{
      margin-bottom: 15px !important;
    }
`;
const PaymentMethod = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 0;
  border-top: 0;
  background-color: #fff;
`;
const StepFiveContainer = styled.div`
    display: flex;
    .account-edit-icon{
      cursor:pointer;
    }
    .freezeDiv{
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 99;
    }
    .freezeDivCredit{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 99;
    }
`;

const CreditCardSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 0 0 20px 20px;
  border-top: 0;
  background-color: #fff;
  .promocode-text-wrapper{
    .app-input-text{
      input{
        max-width: 170px;
      }
    }
  }
`;

const SubHeading2 = styled.h5`
    font-size: 18px;
    padding: 0 15px;
    color: #505050;
`
const FormDetailWrapper = styled.div`
  max-width: 1411px;
  width: 100%;
  border-radius: 10px;
  padding: 24px;
  margin: 0 auto;
  .diverse-spend-selected-style{
    margin-top: -20px;
    margin-left: 5px;
    span{
      padding: 6px 5px 6px 5px;
      border: 1px solid #0000001A;
      background: #dcdcdc4d;
      border-radius: 4px;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: 100 !important;
      font-size: 15px;
    }
  }
  .account-type-option {
    p {
      font-size: 18px;
    }
    @media (max-width: 650px) {
      p {
        font-size: 14px;
      }
    }
  }
  .description {
    display: flex;
    align-items: center;
    h6 {
      font-size: 22px;
      color: #191819;
      line-height: 25px;
      font-family: "latobold";
      margin: 15px 0;
    }
    p {
      font-size: 18px;
      line-height: 22px;
      font-family: "latomedium";
      word-break: break-all;
      flex: 1;
      white-space: nowrap;
      span {
        font-weight: bold;
      }
      :first-child {
        max-width: 262px;
      }
    }
    @media (max-width: 650px) {
      h6 {
        font-size: 20px;
      }
      p {
        font-size: 14px;
      }
    }
  }
`;

const PromoCodeCheckbox = styled.div`
  padding : 0 15px;
  
  .checkbox-container {
    font-size: 16px !important;
  }
`

const RegistrationWraper = styled.div`
  padding: 50px 0 20px;
  .form {
    min-width: auto;
    position: relative;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    border-radius: 10px;
    padding-bottom: 52px;
  }
  @media (min-width: 594px) {
    padding: 20px 0;
    .form {
      min-width: 594px;
    }
  }
`;

const StepText = styled.div`
  display: grid;
  text-align: left;
  line-height: 17px;
  @media (max-width: 550px) {
    span {
      display: flex;
      width: 70px;
    }
  }
`;

const PromoCodeSection = styled.div`
  display: inline-flex;
 
  cursor:pointer;
  div {
    background: transparent;
    color: #61ae24;
    width: auto;
    text-decoration: underline;
  }
  @media (max-width: 962px) {
    /* top: -58px; */
    right: 31px;
    left: auto;
  }
  @media (max-width: 576px) {
    top: -58px;
    right: 31px;
    left: auto;
  }
`;
export {
  RegistrationStepper,
  FormSection,
  ImageSection,
  StepOneContainer,
  FormWrapper,
  ButtonWrapper,
  BackButtonWrapper,
  SubHeading,
  StepTwoContainer,
  AccountTypeSection,
  CardTypeSection,
  StepThreeContainer,
  BusinessInfoSection,
  StepFourContainer,
  PaymentMethod,
  StepFiveContainer,
  CreditCardSection,
  SubHeading2,
  PromoCode,
  CardTypeSectionStripe,
  FormDetailWrapper,
  PromoCodeCheckbox,
  RegistrationWraper,
  StepText,
  PromoCodeSection,
};
